export default __webpack_public_path__ + "static/reco@2x-51e3ca173cab6679f52ae76047388ad3.jpg";